import styled from "styled-components"
import AsciiImageViewer from "../components/AsciiImageViewer"

export default function AboutGrid() {
    const PhotoDump = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 50%;
    overflow: hidden;
`

    const Bio = styled.div `
    flex: 1;
    width: 100%;
    height: 100%;
    font-family: frensel;
    font-size: 20pt;
    line-height: 30pt;

    @media screen and (max-width: 1000px) {
    font-size: 15pt;
    line-height: 23pt;
    }

    @media screen and (max-width: 500px) {
    font-size: 12pt;
    line-height: 15pt;
    }
    `

    const Parent = styled.div `
    display: flex;
    flex-direction: row;
    height: 700px;
    column-gap: 30px;
    `

    const Mini = styled.div`
    display: flex;
    flex: 1;                 /* takes remaining space */
    width: 100%;
    height: 0;               /* IMPORTANT */
    overflow: hidden;
`

    
const MiniImg = styled.img`
    flex: 1;
    width: 0;
    height: 100%;
    object-fit: cover;
    object-position: top;
    @media screen and (min-width: 1000px) {
    object-position: center 30%;
    }
`

    
    const TopImage = styled.img`
        flex: 2;                 /* takes more space */
        width: 100%;
        height: 0;               /* IMPORTANT for flex height */
        object-fit: cover;
        object-position: center 30%;
    `


    return (
        <Parent>
            <PhotoDump className="snake-border">
                <TopImage src={"https://i.scdn.co/image/ab6761670000ecd4de5811eaf19cea6c0183f1d8"} />
                <Mini>
                    <MiniImg src={"https://i.scdn.co/image/ab6761670000ecd492e57da5268d3fca7f6a6230"}/>
                    <MiniImg src={"https://i.scdn.co/image/ab6761670000ecd42d3b74b37b5e922c47506913"} />
                </Mini>  
            </PhotoDump>
            <Bio>
                HYPERPUP (aka Keres Wolfe) is the music project of 21 year old Atlanta musician Willow Rubenstein which can only be described as “hyper”, contantly shifting styles and tones every few months. Taking loose inspiration from everyone around her, the project has shifted anywhere from house to punk to techno. Where she will go next with is a mystery to everyone, including herself, at all times.
            </Bio>
        </Parent>
    )
}